import {Component, Inject, OnDestroy} from '@angular/core';
import {
  VehicleBasicInformationEditComponent
} from '../vehicle-basic-information-edit/vehicle-basic-information-edit.component';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {VehicleModel} from '../../../../../shared/models/vehicle.model';
import {MatButton} from '@angular/material/button';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {VehicleBasicInformationModel} from '../model/vehicle-basic-information-model';
import {VehiclesService} from '../../../../../data/vehicles/vehicles.service';
import {MatProgressBar} from '@angular/material/progress-bar';
import {Subscription} from 'rxjs';
import {MatError} from '@angular/material/form-field';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-create-vehicle-dialog',
  standalone: true,
  imports: [
    VehicleBasicInformationEditComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBar,
    MatError,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatIcon
  ],
  templateUrl: './create-vehicle-dialog.component.html',
})
export class CreateVehicleDialogComponent implements OnDestroy {
  vehicle: VehicleBasicInformationModel = {
    active: true
  } as VehicleBasicInformationModel;

  formGroup: FormGroup;

  isCreating = false;
  createError?: string;

  private readonly subscriptions: Subscription[] = [];

  constructor(private readonly dialogRef: MatDialogRef<VehicleModel>,
              private readonly vehicleService: VehiclesService,
              @Inject(MAT_DIALOG_DATA) private readonly data: { groupId: number },
              readonly fb: FormBuilder) {
    this.formGroup = fb.group({
      vehicle: fb.control(this.vehicle)
    });

    this.subscriptions.push(
      this.formGroup.events.subscribe(() => {
        delete this.createError;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  createVehicle(action: 'detail' | 'list' = 'detail') {
    const {value: {vehicle}} = this.formGroup;

    this.isCreating = true;
    vehicle.groupId = this.data.groupId;
    this.vehicleService.createVehicle(vehicle).then(createdVehicle => {
      this.dialogRef.close({action, vehicle: createdVehicle});
    }).catch(error => {
      this.createError = error;
    }).finally(() => {
      this.isCreating = false;
    });
  }
}
